/* Marwo theme — vanilla JS, no dependencies */
(() => {
  'use strict';
  const T = window.theme || { routes: {}, strings: {} };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- Utilities ---------- */
  function formatMoney(cents, format = T.moneyFormat || '{{amount}}') {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    const re = /\{\{\s*(\w+)\s*\}\}/;
    const fmt = (n, precision, thousands = ',', decimal = '.') => {
      const parts = (n / 100).toFixed(precision).split('.');
      return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    };
    const match = format.match(re);
    let value;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = fmt(cents, 2, ' ', '.'); break;
      default: value = fmt(cents, 2);
    }
    const div = document.createElement('div');
    div.innerHTML = format.replace(re, value);
    return div.textContent;
  }

  const debounce = (fn, wait = 250) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), wait); }; };

  let toastTimer;
  function toast(message) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 3500);
  }

  /* ---------- Drawers (menu + cart) with focus trap ---------- */
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"]), summary';
  let activeDrawer = null;
  let lastFocus = null;

  function openDrawer(name) {
    const drawer = $(`[data-drawer="${name}"]`);
    if (!drawer) return;
    if (activeDrawer && activeDrawer !== drawer) closeDrawer(false);
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => drawer.classList.add('is-open')));
    document.body.classList.add('is-locked');
    activeDrawer = drawer;
    $$(`[data-drawer-open="${name}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const panel = $('.drawer__panel', drawer);
    setTimeout(() => (panel && panel.focus()), 60);
  }

  function closeDrawer(restore = true) {
    const drawer = activeDrawer;
    if (!drawer) return;
    drawer.classList.remove('is-open');
    $$('[data-drawer-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    document.body.classList.remove('is-locked');
    activeDrawer = null;
    setTimeout(() => { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 320);
    if (restore && lastFocus) lastFocus.focus();
  }

  function trapFocus(e, container) {
    const nodes = $$(FOCUSABLE, container).filter((n) => n.offsetParent !== null);
    if (!nodes.length) return;
    const first = nodes[0];
    const last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.drawerOpen); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); }
  });

  document.addEventListener('keydown', (e) => {
    const searchModal = $('[data-search-modal]');
    if (e.key === 'Escape') {
      if (activeDrawer) closeDrawer();
      else if (searchModal && !searchModal.hidden) closeSearch();
      else {
        const item = document.activeElement && document.activeElement.closest('.nav__item');
        if (item) { item.classList.add('is-closed'); item.querySelector('.nav__link').focus(); }
      }
    }
    if (e.key === 'Tab') {
      if (activeDrawer) trapFocus(e, $('.drawer__panel', activeDrawer));
      else if (searchModal && !searchModal.hidden) trapFocus(e, $('.search-modal__panel', searchModal));
    }
  });
  document.addEventListener('mouseover', (e) => {
    const item = e.target.closest('.nav__item.is-closed');
    if (item && !item.contains(e.relatedTarget)) item.classList.remove('is-closed');
  });
  document.addEventListener('focusin', (e) => {
    $$('.nav__item.is-closed').forEach((i) => { if (!i.contains(e.target)) i.classList.remove('is-closed'); });
  });

  /* ---------- Sticky header shadow ---------- */
  const onScroll = () => { const h = $('[data-header]'); if (h) h.classList.toggle('is-scrolled', window.scrollY > 10); };
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------- Cart ---------- */
  const SECTION = 'cart-drawer';

  function renderCartDrawer(html) {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.getElementById('CartDrawerContent');
    const current = document.getElementById('CartDrawerContent');
    if (fresh && current) {
      current.replaceWith(fresh);
      updateCartCount(parseInt(fresh.dataset.itemCount, 10) || 0);
    }
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      el.classList.remove('is-bumped'); void el.offsetWidth; el.classList.add('is-bumped');
    });
    $$('[data-cart-count-label]').forEach((el) => { el.textContent = String(count); });
  }

  async function refreshCartDrawer() {
    const res = await fetch(`${T.routes.root}?sections=${SECTION}`, { credentials: 'same-origin' });
    const data = await res.json();
    renderCartDrawer(data[SECTION]);
  }

  async function postJSON(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
    return data;
  }

  function afterAdd(data) {
    if (T.cartType === 'page') { window.location.href = T.routes.cart; return; }
    renderCartDrawer(data.sections && data.sections[SECTION]);
    openDrawer('cart');
  }

  /* Intercept every add-to-cart form on the site (product page, quick add, bundles) */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const errorEl = form.querySelector('[data-form-error]');
    const label = button ? button.innerHTML : '';
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); button.textContent = T.strings.adding; }
    if (errorEl) errorEl.hidden = true;
    try {
      const fd = new FormData(form);
      fd.append('sections', SECTION);
      fd.append('sections_url', window.location.pathname);
      const res = await fetch(`${T.routes.cartAdd}.js`, { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
      afterAdd(data);
    } catch (err) {
      if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; } else { toast(err.message); }
    } finally {
      if (button) { button.disabled = false; button.removeAttribute('aria-busy'); button.innerHTML = label; }
    }
  });

  /* Quantity changes inside the drawer */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cart-qty]');
    if (!btn) return;
    const line = btn.closest('[data-line]');
    if (!line) return;
    e.preventDefault();
    const drawer = $('[data-drawer="cart"]');
    drawer && drawer.classList.add('is-loading');
    try {
      const data = await postJSON(`${T.routes.cartChange}.js`, {
        line: parseInt(line.dataset.line, 10),
        quantity: Math.max(0, parseInt(btn.dataset.cartQty, 10)),
        sections: SECTION,
        sections_url: window.location.pathname
      });
      renderCartDrawer(data.sections && data.sections[SECTION]);
      const panel = $('.drawer__panel', drawer);
      panel && panel.focus();
    } catch (err) { toast(err.message); }
    finally { drawer && drawer.classList.remove('is-loading'); }
  });

  /* Cart icon opens the drawer */
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-cart-open]');
    if (!link || T.cartType === 'page' || document.body.classList.contains('template-cart')) return;
    e.preventDefault();
    openDrawer('cart');
  });

  /* ---------- Predictive search ---------- */
  function openSearch() {
    const searchModal = $('[data-search-modal]');
    if (!searchModal) return;
    lastFocus = document.activeElement;
    searchModal.hidden = false;
    document.body.classList.add('is-locked');
    $$('[data-search-open]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    setTimeout(() => { const i = $('[data-search-input]', searchModal); i && i.focus(); }, 30);
  }
  function closeSearch() {
    const searchModal = $('[data-search-modal]');
    if (!searchModal) return;
    searchModal.hidden = true;
    document.body.classList.remove('is-locked');
    $$('[data-search-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    else if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
  });

  let searchController;
  const runSearch = debounce(async (term) => {
    const results = $('[data-predictive-results]');
    if (!results) return;
    if (term.length < 2) { results.innerHTML = ''; return; }
    if (searchController) searchController.abort();
    searchController = new AbortController();
    try {
      const url = `${T.routes.predictiveSearch}?q=${encodeURIComponent(term)}&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search`;
      const res = await fetch(url, { signal: searchController.signal });
      if (!res.ok) throw new Error(res.status);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const inner = doc.getElementById('PredictiveResultsInner');
      results.innerHTML = inner ? inner.outerHTML : '';
    } catch (err) {
      if (err.name !== 'AbortError') results.innerHTML = '';
    }
  }, 250);
  document.addEventListener('input', (e) => {
    if (e.target.matches('[data-search-input]')) runSearch(e.target.value.trim());
  });

  /* ---------- Quantity inputs ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    const input = btn.closest('[data-qty]').querySelector('input');
    const step = btn.hasAttribute('data-qty-plus') ? 1 : -1;
    input.value = Math.max(parseInt(input.min || 1, 10), (parseInt(input.value, 10) || 1) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product page: variants + gallery ---------- */
  function initProduct(root) {
    const section = (root.matches && root.matches('[data-product-section]')) ? root : $('[data-product-section]', root);
    if (!section || section.dataset.ready) return;
    section.dataset.ready = 'true';

    const track = $('[data-gallery-track]', section);
    const thumbs = $$('[data-gallery-thumb]', section);
    const goToMedia = (id, smooth = true) => {
      if (!track || !id) return;
      const slide = $(`[data-media-id="${id}"]`, track);
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      thumbs.forEach((t) => { const on = t.dataset.galleryThumb === String(id); t.classList.toggle('is-active', on); on ? t.setAttribute('aria-current', 'true') : t.removeAttribute('aria-current'); });
    };
    thumbs.forEach((t) => t.addEventListener('click', () => goToMedia(t.dataset.galleryThumb)));
    if (track && thumbs.length) {
      track.addEventListener('scroll', debounce(() => {
        const idx = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
      }, 80), { passive: true });
    }

    const picker = $('[data-variant-picker]', section);
    if (!picker) return;
    const variants = JSON.parse($('[data-variants-json]', picker).textContent);
    const radios = $$('input[data-option-index]', picker);
    const idInput = $('[data-variant-id]', section);
    const addBtn = $('[data-add-button]', section);
    const priceWrap = $('[data-product-price] [data-price]', section);
    const inventory = $('[data-inventory]', section);

    const selectedOptions = () => {
      const opts = [];
      radios.forEach((r) => { if (r.checked) opts[parseInt(r.dataset.optionIndex, 10)] = r.value; });
      return opts;
    };

    const markAvailability = (opts) => {
      radios.forEach((r) => {
        const idx = parseInt(r.dataset.optionIndex, 10);
        const test = opts.slice(); test[idx] = r.value;
        const ok = variants.some((v) => v.available && v.options.every((o, i) => i === idx || o === test[i] || test[i] === undefined) && v.options[idx] === r.value);
        const label = picker.querySelector(`label[for="${r.id}"]`);
        if (label) label.classList.toggle('is-unavailable', !ok);
      });
    };

    const update = () => {
      const opts = selectedOptions();
      $$('[data-option-value]', picker).forEach((el) => { el.textContent = opts[parseInt(el.dataset.optionValue, 10)] || ''; });
      markAvailability(opts);
      const variant = variants.find((v) => v.options.every((o, i) => o === opts[i]));
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = T.strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (addBtn) { addBtn.disabled = !variant.available; addBtn.textContent = variant.available ? T.strings.addToCart : T.strings.soldOut; }
      if (priceWrap) {
        const onSale = variant.compare_at_price > variant.price;
        priceWrap.classList.toggle('price--sale', onSale);
        let html = `<span class="price__current">${formatMoney(variant.price)}</span>`;
        if (onSale) {
          html += `<s class="price__compare">${formatMoney(variant.compare_at_price)}</s>`;
          html += `<span class="price__savings badge badge--sale">${T.strings.save} ${formatMoney(variant.compare_at_price - variant.price)}</span>`;
        }
        priceWrap.innerHTML = html;
      }
      if (inventory) inventory.innerHTML = variant.inventory_html;
      if (variant.media_id) goToMedia(variant.media_id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    picker.addEventListener('change', update);
    markAvailability(selectedOptions());
  }

  /* ---------- Collection filters ---------- */
  function submitFacets(form) {
    const params = new URLSearchParams();
    new FormData(form).forEach((value, key) => { if (String(value).trim() !== '') params.append(key, value); });
    const results = $('.collection-layout__results');
    results && results.classList.add('is-loading');
    window.location.href = `${form.action.split('?')[0]}?${params.toString()}`;
  }
  const debouncedFacets = debounce(submitFacets, 700);
  document.addEventListener('change', (e) => {
    const el = e.target.closest('[data-facets-autosubmit]');
    if (!el) return;
    const form = el.closest('[data-facets-form]');
    const drawerOpen = form.classList.contains('is-open');
    if (el.name === 'sort_by') { submitFacets(form); return; }
    if (drawerOpen) return; // on mobile, wait for "Show results"
    el.type === 'number' ? debouncedFacets(form) : submitFacets(form);
  });
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-facets-form]');
    if (!form) return;
    e.preventDefault();
    submitFacets(form);
  });
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-facets-open]');
    const close = e.target.closest('[data-facets-close]');
    if (!open && !close) return;
    const form = (open || close).closest('[data-facets-form]');
    const isOpen = !!open;
    form.classList.toggle('is-open', isOpen);
    document.body.classList.toggle('is-locked', isOpen);
    const btn = $('[data-facets-open]', form);
    btn && btn.setAttribute('aria-expanded', String(isOpen));
    if (isOpen) { const d = $('[data-facets-drawer]', form); const f = d && $(FOCUSABLE, d); f && f.focus(); } else { btn && btn.focus(); }
  });

  /* ---------- Build-your-own bundle ---------- */
  function initBundle(root) {
    $$('[data-bundle]', root).concat(root.matches && root.matches('[data-bundle]') ? [root] : []).forEach((el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = 'true';
      bundle(el);
    });
  }

  function bundle(root) {
    const items = $$('[data-bundle-item]', root);
    const sizeInputs = $$('[data-bundle-size]', root);
    if (!sizeInputs.length || !items.length) return;
    if (!sizeInputs.some((i) => i.checked)) sizeInputs[0].checked = true;

    const picks = []; // ordered list of variant ids
    const byId = new Map(items.map((i) => [i.dataset.variantId, i]));
    const current = () => sizeInputs.find((i) => i.checked);
    const size = () => parseInt(current().value, 10);
    const discountPct = () => parseInt(current().dataset.discount, 10) || 0;
    const els = {
      status: $('[data-bundle-status]', root),
      progress: $('[data-bundle-progress]', root),
      slots: $('[data-bundle-slots]', root),
      normal: $('[data-bundle-normal]', root),
      discount: $('[data-bundle-discount]', root),
      final: $('[data-bundle-final]', root),
      savings: $('[data-bundle-savings]', root),
      add: $('[data-bundle-add]', root),
      summary: $('.bundle__summary', root)
    };

    const render = () => {
      const target = size();
      const count = picks.length;
      items.forEach((item) => {
        const n = picks.filter((id) => id === item.dataset.variantId).length;
        $('[data-bundle-count]', item).textContent = n;
        $('[data-bundle-minus]', item).disabled = n === 0;
        $('[data-bundle-plus]', item).disabled = count >= target;
        item.classList.toggle('is-selected', n > 0);
      });
      const left = target - count;
      els.status.textContent = left > 0 ? T.strings.bundleChoose.replace('[count]', left) : T.strings.bundleReady;
      const pct = Math.round((count / target) * 100);
      els.progress.setAttribute('aria-valuenow', pct);
      $('.progress__bar', els.progress).style.width = `${pct}%`;
      els.slots.style.gridTemplateColumns = `repeat(${Math.min(target, 6)}, 1fr)`;
      els.slots.innerHTML = Array.from({ length: target }, (_, i) => {
        const id = picks[i];
        const item = id && byId.get(id);
        const img = item && item.dataset.image;
        return `<li class="bundle__slot${item ? ' is-filled' : ''}">${img ? `<img src="${img}" alt="${item.dataset.title}" width="80" height="80" loading="lazy">` : ''}</li>`;
      }).join('');
      const normal = picks.reduce((sum, id) => sum + parseInt(byId.get(id).dataset.price, 10), 0);
      const discount = count === target ? Math.round((normal * discountPct()) / 100) : 0;
      els.normal.textContent = formatMoney(normal);
      els.discount.textContent = discount ? `-${formatMoney(discount)}` : formatMoney(0);
      els.final.textContent = formatMoney(normal - discount);
      els.savings.textContent = formatMoney(discount);
      els.add.disabled = count !== target;
    };

    root.addEventListener('click', async (e) => {
      const plus = e.target.closest('[data-bundle-plus]');
      const minus = e.target.closest('[data-bundle-minus]');
      if (plus || minus) {
        const id = (plus || minus).closest('[data-bundle-item]').dataset.variantId;
        if (plus) { if (picks.length >= size()) { toast(T.strings.bundleFull); return; } picks.push(id); }
        else { const idx = picks.lastIndexOf(id); if (idx > -1) picks.splice(idx, 1); }
        render();
        return;
      }
      if (e.target.closest('[data-bundle-reset]')) { picks.length = 0; render(); return; }
      const toggle = e.target.closest('[data-bundle-toggle]');
      if (toggle) {
        const expanded = els.summary.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', String(expanded));
        return;
      }
      if (e.target.closest('[data-bundle-add]')) addBundle();
    });

    sizeInputs.forEach((input) => input.addEventListener('change', () => {
      while (picks.length > size()) picks.pop();
      render();
    }));

    async function addBundle() {
      const target = size();
      if (picks.length !== target) return;
      const bundleId = `box-${Date.now().toString(36)}`;
      const qty = picks.reduce((m, id) => m.set(id, (m.get(id) || 0) + 1), new Map());
      const items = Array.from(qty, ([id, quantity]) => ({ id: parseInt(id, 10), quantity, properties: { _bundle_id: bundleId, _bundle_size: String(target) } }));
      const code = (current().dataset.code || '').trim();

      // Hook for bundle apps: listen for this event and call preventDefault() to take over.
      const hook = new CustomEvent('marwo:bundle:before-add', { cancelable: true, detail: { items, size: target, discount: discountPct(), code, bundleId } });
      if (!document.dispatchEvent(hook)) return;

      els.add.disabled = true;
      const label = els.add.textContent;
      els.add.textContent = T.strings.adding;
      try {
        const data = await postJSON(`${T.routes.cartAdd}.js`, { items, sections: SECTION, sections_url: window.location.pathname });
        if (code) {
          await fetch(`${T.routes.root}discount/${encodeURIComponent(code)}`, { credentials: 'same-origin' });
          await refreshCartDrawer();
          if (T.cartType === 'page') window.location.href = T.routes.cart; else openDrawer('cart');
        } else {
          afterAdd(data);
        }
        picks.length = 0;
      } catch (err) {
        toast(err.message);
      } finally {
        els.add.textContent = label;
        render();
      }
    }

    render();
  }

  /* ---------- Carousels ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!btn) return;
    const track = $('[data-carousel-track]', btn.closest('[data-carousel]'));
    if (!track) return;
    const dir = btn.hasAttribute('data-carousel-next') ? 1 : -1;
    const item = track.firstElementChild;
    const step = item ? item.getBoundingClientRect().width + 16 : track.clientWidth;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  });

  /* ---------- Product recommendations ---------- */
  function initRecommendations(root) {
    $$('[data-recommendations]', root).forEach(async (el) => {
      if (el.dataset.ready || !el.dataset.url) return;
      el.dataset.ready = 'true';
      try {
        const res = await fetch(el.dataset.url);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        else el.closest('.section') && (el.closest('.section').hidden = true);
      } catch (err) { /* recommendations are optional */ }
    });
  }

  /* ---------- Init + theme editor support ---------- */
  function initFooter(root) {
    if (window.matchMedia('(max-width: 749px)').matches) $$('.footer__details', root).forEach((d) => d.removeAttribute('open'));
  }

  function init(root = document) {
    initFooter(root);
    initProduct(root);
    initBundle(root);
    initRecommendations(root);
  }
  document.addEventListener('DOMContentLoaded', () => { init(); onScroll(); });
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const slide = e.target.closest('[data-carousel-track] > *');
    if (slide) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  });

  window.MarwoTheme = { formatMoney, openDrawer, closeDrawer, refreshCartDrawer };
})();
